import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ZoomRegular from './zoom-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ZoomRegular {...validProps} />;
}
SvgComponent.iconName = 'zoomRegular';

export const ZoomRegularIcon = svgIconWrapper(SvgComponent);
